export default __webpack_public_path__ + "static/khoa-hoc-online-text-2-94807d49af3cf3c77a079ccc79478f24.png";